<template>
    <div class="card">
        <div class="card-header">
            <h4 class="card-title">
                {{$t("comparativaVentasAnteriores")}}
            </h4>
            <p class="card-category">
                {{$t("graficaDeConsumoRespectoAHistoricoDeSesiones")}}
            </p>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <canvas id="charte"></canvas>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <hr>
            <div class="stats">
                <i class="fa fa-clock"></i> {{lastDate | timeago}}
            </div>
        </div>
    </div>
</template>
<script>

    import swal from 'sweetalert2'

    export default {
        created() {
            this.getConsumoFechasAnteriores();

        },
        props: ['onlineDetails', 'lastDate', 'idBusiness'],
        data() {
            return {
            }
        },
        methods: {
            getConsumoFechasAnteriores() {

                var tpvs = [];
                this.onlineDetails.forEach(function (x) {
                    if (x && x.online == 1) {
                        tpvs.push(x.idTpv);
                    }
                });

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        listTpv: JSON.stringify(tpvs),
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "online/getConsumoFechaAnteriores", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.initChart(response.data.result);
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            initChart(listHours) {

                var labels = listHours.map(function (x) {
                    return x.name;
                });

                var data = listHours.map(function (x) {
                    return x.import;
                });

                if(this.$chart){
                    this.$chart.destroy();
                }

                this.$chart = new Chart('charte', {
                    type: 'bar',
                    data: {
                        labels: labels,
                        datasets: [{
                            data: data,
                            backgroundColor: ["rgba(70,191,189,0.6)",
                                "rgba(253,180,92,0.6)",
                                "rgba(247,70,74,0.6)"],
                            pointBackgroundColor: "rgba(0,0,0,1)",
                            borderColor: "rgba(0,0,0,0.6)",
                            borderWidth: 1
                        }]
                    },
                    options: {
                        maintainAspectRatio: false,
                        legend: {
                            display: false,
                        }
                    }
                });


            }

        },
        watch: {
            onlineDetails: function (newOnlineDetails, oldOnlineDetails) {
                this.getConsumoFechasAnteriores();
            }
        },


    }
</script>
<style scoped>
    .card-body {
        padding: 10px 15px;
    }

    .title {
        font-weight: bold;
    }

    tfoot tr td {
        font-size: 1.2em;
        color: #fff;
        text-shadow: 1px 1px #111;
        font-weight: bold;
    }

    .card-category {
        color: #9a9a9a
    }


</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Online/Widgets/ConsumoFechasAnteriores.vue